function Faq() {
  return (
    <section className='mt-16'>
      <div className='max-w-6xl mx-auto px-4 sm:px-6'>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-3 leading-tighter'>What is The 100 Club?</h3>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            The 100 Club is a private mastermind community for founders in Singapore.
          </p>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            Members of The 100 Club run growing businesses in Singapore, across a wide array of industries. Some are
            bootstrapped, others venture-backed. But all our members seek belonging, support, and connection with a
            selective group of their peers.
          </p>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            Members who join us get matched into a mastermind group of 8 founders with an executive facilitator, that
            meets every month to discuss business challenges. Additionally, they can expect to be part of a digital
            community, an in-person community, have access to speakers, and a membership card to claim perks throughout
            Singapore.
          </p>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-3 leading-tighter'>What is a mastermind?</h3>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            It's a peer support group of 8 founders at a similar business stage, that meet monthly to work through their
            challenges in a safe environment.
          </p>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-3 leading-tighter'>
            Do I need to pay for this?
          </h3>

          <p className='text-xl md:text-2xl text-text-main mb-8'>Nope, it's a free trial session.</p>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
        <div className='text-center'>
          <h3 className='text-2xl md:text-4xl font-black text-text-main mb-3 leading-tighter'>
            What do I need to do to join?
          </h3>
          <p className='text-xl md:text-2xl text-text-main mb-8'>
            You've been personally invited by our founders because they believe you'll be a good fit for the community
            and our mastermind groups. All you need to do now is{' '}
            <a className='underline' href='https://buy.stripe.com/28o9EFdMm8qC7QI4gk'>
              register for the trial here
            </a>
            . Once done, you'll receive an email to join our community and be matched into your personal mastermind.
          </p>
        </div>
        <div className='text-center'>
          <span className='mx-auto block bg-gradient-to-r from-[#002140] to-[#002140] h-1 w-40 mb-16 rounded-full'></span>
        </div>
      </div>
    </section>
  );
}

export default Faq;
